import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withKeys as _withKeys, createElementVNode as _createElementVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = ["id", "value", "readonly"]

import { ref, PropType, watchEffect } from 'vue';
import ValidationLabel from '@/shared/components/ValidationLabel.vue';
import { generateUUID } from '@/guiide/ts/utilities';


export default /*@__PURE__*/_defineComponent({
  __name: 'NumberInput',
  props: {
    modelValue: {
        type: [Number, null] as PropType<number | null>,
        default: null
    },
    description: { type: String, default: "" },
    abbreviatedDescription: { type: String, default: "" },
    max: { type: Number, default: 100 },
    min: { type: Number, default: 1 },
    optional: { type: Boolean, default: false },
    isReadOnly: { type: Boolean, default: false },
    showLabel: { type: Boolean, default: true }
},
  emits: ['update:modelValue', 'entered'],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const id = generateUUID();
const txtNumberInput = ref(null);
const label = ref(null);
const displayValue = ref(props.modelValue?.toString() ?? '');
const hasFocus = ref(false);

const updateModel = (event: Event) => {
    const value = (event.target as HTMLInputElement).value;

    if (value === "") {
        label.value.hideAnyWarnings();
        emit('update:modelValue', null);
        return;
    }

    if (!/^\d+$/.test(value)) {
        return;
    }

    const numberValue = parseInt(value, 10);

    isValidInternal(numberValue);

    if (isNaN(numberValue)) {
        emit('update:modelValue', null);
    } else {
        emit('update:modelValue', numberValue);
    }
};

watchEffect(() => {
    if (props.modelValue === null) {
        displayValue.value = "";
        return;
    }

    if (hasFocus.value) {
        displayValue.value = props.modelValue.toString();
    } else {
        displayValue.value = props.modelValue.toLocaleString();
    }
});

const onlyNumeric = (event: KeyboardEvent) => {
    const keyValue = event.key;
    if (!keyValue.match(/[0-9]/)) {
        event.preventDefault();
    }
};

const isValid = (): boolean => {
    return isValidInternal(props.modelValue);
}

function isValidInternal(numberToValidate: number | null): boolean {
    if (numberToValidate === null) {
        if (!props.optional) {
            label.value.warn("required");
            return false;
        }
        return true;
    }
    
    if (numberToValidate! > props.max) {
        const maxFormatted = props.max.toLocaleString();
        label.value.warn(`<= ${maxFormatted}`);
        return false;
    } else if (numberToValidate! < props.min) {
        const minFormatted = props.min.toLocaleString();
        label.value.warn(`>= ${minFormatted}`);
        return false;
    }

    label.value.hideAnyWarnings();
    return true;
}

const hideAnyWarnings = () => {
    label.value.hideAnyWarnings();
}

function takeFocus() {
    txtNumberInput.value.focus();
}

__expose({ isValid, hideAnyWarnings, takeFocus });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["input-icon", { 'form-floating': __props.showLabel }])
    }, [
      _createElementVNode("input", {
        type: "text",
        ref_key: "txtNumberInput",
        ref: txtNumberInput,
        id: `input-${_unref(id)}`,
        value: displayValue.value,
        readonly: __props.isReadOnly,
        onInput: updateModel,
        onKeypress: onlyNumeric,
        onFocus: _cache[0] || (_cache[0] = ($event: any) => (hasFocus.value = true)),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (hasFocus.value = false)),
        onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (emit('entered')), ["enter"])),
        class: "form-control"
      }, null, 40, _hoisted_2),
      _cache[3] || (_cache[3] = _createElementVNode("i", null, "£", -1)),
      _withDirectives(_createVNode(ValidationLabel, {
        ref_key: "label",
        ref: label,
        elementId: `input-${_unref(id)}`,
        text: __props.description,
        abbreviatedText: __props.abbreviatedDescription
      }, null, 8, ["elementId", "text", "abbreviatedText"]), [
        [_vShow, __props.showLabel]
      ])
    ], 2)
  ]))
}
}

})